import { Injectable } from '@angular/core';
import { HeightUnit, WeightUnit } from '../../components/header/components/interface/interface';
import { StorageBrowser } from '../storage.service';
import { UserService } from '../user.service';

@Injectable({
  providedIn: 'root',
})
export class ConversionBmiService {
  public preferredWeightUnit: WeightUnit;
  public preferredLengthUnit: HeightUnit;


  constructor( private userService: UserService, private storageBrowser: StorageBrowser) {
    const currUser = this.userService.currentUser.getValue() || {};
    this.preferredWeightUnit = currUser.preferredWeightUnit || WeightUnit.LB;
    this.preferredLengthUnit = currUser.preferredLengthUnit || HeightUnit.IN;
  }

  /**
 * Calculates BMI using metric units:
 * Height in centimeters, Weight in kilograms.
 * Formula: BMI = weight (kg) / [height (m)]²
 */
calculateBmi(heightCm: number, weightKg: number): number {
  if (!heightCm || !weightKg || heightCm <= 0 || weightKg <= 0) return 0;

  const heightInMeters = heightCm / 100;
  const bmi = weightKg / (heightInMeters * heightInMeters);

  return isFinite(bmi) && !isNaN(bmi) ? Number(bmi.toFixed(2)) : 0;
}

formatWithUnit(bmi): string {
    const weightUnit = this.preferredWeightUnit;
    const heightUnit = this.preferredLengthUnit;
    return `${bmi} (${weightUnit}/${heightUnit}²):`;
}


}
